import api from "../../index";

export const AllCurrency = (params) => api.get(`currency/get-all-currency-history?${params}`);
export const AllCurrencySync = (params) => api.get(`currency/get-currency-exchange-sync?${params}`);
export const UpdatUpdateCurrencyApi = (params) => api.put('currency/update-currency-rate', params);
